import { useFirestore, useFirestoreDocData } from "reactfire";
import { collection, doc, setDoc, deleteDoc } from "firebase/firestore";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import { BreadcrumbItem, Breadcrumbs, Button, ButtonGroup, Card, CardBody, Code, Kbd, Tab, Tabs } from "@nextui-org/react";
import { Editor } from "./develop";
import { ExtractorType } from "../../types/types";
import { JSONSchema7 } from "json-schema";
import { MonitorDashboard } from "../common/monitor";
import { Publish } from "./publish";
import Extractors from "./extractors";

export const Extractor = () => {
    const { id } = useParams();
    const [editedSchema, setEditedSchema] = useState<JSONSchema7>();
    const navigate = useNavigate();

    const firestore = useFirestore();
    const { data: extractor } = useFirestoreDocData(doc(firestore, 'extractors/' + id), { idField: 'id' });


    const onSchemaChange = (schema: JSONSchema7) => {
        setEditedSchema(schema);
    }

    const saveExtractor = () => {
        //save document in firestore 
        setDoc(doc(collection(firestore, 'extractors'), id), {
            ...extractor,
            schema: editedSchema,
            instruction: '',
        });
    }


    const deletExtractor = () => {
        //delete document in firestore
        deleteDoc(doc(firestore, 'extractors/' + id));
        navigate(`/`)
    }

    return (
        <div className="">
            <div className="flex flex-row items-end justify-between">
                <div className=" ">
                    <Breadcrumbs>
                        <BreadcrumbItem><Link to="/extractors">Home</Link></BreadcrumbItem>
                        <BreadcrumbItem>Extractor</BreadcrumbItem>
                    </Breadcrumbs>
                    <div className="text-2xl mt-4 font-bold">{extractor?.name} <Code size="sm">{id}</Code></div>
                    <div className="text-md">{extractor?.description} </div>
                </div>
                <div className="px-4 align-bottom flex-col gap-4">

                    <div className="flex">
                        <ButtonGroup>
                            <Button color="primary" aria-label="Save" onClick={saveExtractor}>
                                <Kbd keys={["command"]}>S</Kbd>Save
                            </Button>
                            <Button color="danger" aria-label="Delete" onClick={deletExtractor}>
                                Delete
                            </Button>
                        </ButtonGroup>
                    </div>
                </div>
            </div>
            <div className="flex w-full flex-col mt-8">
                <Tabs aria-label="Dynamic tabs" >
                    <Tab key="Develop" title="Develop">
                        <Card>
                            <CardBody>
                                {extractor &&
                                    <Editor ext={extractor as ExtractorType} onSchemaChange={onSchemaChange} saveExtractor={saveExtractor} />
                                }
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="Publish" title="Publish">
                        <Card>
                            <CardBody>
                                {extractor &&
                                    <Publish ext={extractor as ExtractorType} />
                                }
                            </CardBody>
                        </Card>
                    </Tab>
                    <Tab key="Monitor" title="Monitor">
                        <Card>
                            <CardBody>
                                <MonitorDashboard dox={extractor as ExtractorType} />
                            </CardBody>
                        </Card>
                    </Tab>
                </Tabs>
            </div>
        </div>
    )
}